import { coalesce } from '../../../utils/utils';
import { ModalActionType } from './actionTypes';
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const DELETE_AUTO_RMD = 'DELETE_AUTO_RMD';
export const EXCHANGE_RETIREMENT_AGREEMENT = 'EXCHANGE_RETIREMENT_AGREEMENT';
export const EXCHANGE_TAXABLE_AGREEMENT = 'EXCHANGE_RETIREMENT_AGREEMENT';
export const ADD_BANK_MODAL = 'ADD_BANK_MODAL';
export const DELETE_CHARITY_MODAL = 'DELETE_CHARITY_MODAL';
export const ADD_SCHOOL_MODAL = 'ADD_SCHOOL_MODAL';
export const ADD_CHARITY_MODAL = 'ADD_CHARITY_MODAL';
export const DELETE_SCHOOL_MODAL = 'DELETE_SCHOOL_MODAL';
export const ADD_FUND_MODAL = 'ADD_FUND_MODAL';
export const CONFIRM_IRA_DISTRIBUTION_MODAL = 'CONFIRM_IRA_DISTRIBUTION_MODAL';
export const DISTRIBUTION_TRANSACTIONS = 'DISTRIBUTION_TRANSACTIONS';
export const AWARENESS_MODULE_MODAL = 'AWARENESS_MODULE_MODAL';
export const BALANCES_AS_OF_MODAL = 'BALANCES_AS_OF_MODAL';
export const APP_TRADE_DATE = 'APP_TRADE_DATE';
export const BUCKET_ROLL = 'BUCKET_ROLL';
export const CANCEL_TRADE_CONFIRMATION_MODAL =
  'CANCEL_TRADE_CONFIRMATION_MODAL';
export const COLLEGE_DISTRIBUTE_FUND_MIN_MAX_MODAL =
  'COLLEGE_DISTRIBUTE_FUND_MIN_MAX_MODAL';
export const CONTRIBUTION_WINDOW_CLOSED_MODAL =
  'CONTRIBUTION_WINDOW_CLOSED_MODAL';
export const DAILY_MAX_EXCEEDED_MODAL = 'DAILY_MAX_EXCEEDED_MODAL';
export const EXCHANGE_FROM_FUND_MIN_MAX_MODAL =
  'EXCHANGE_FROM_FUND_MIN_MAX_MODAL';
export const IRA_CONTRIBUTIONS_MODAL = 'IRA_CONTRIBUTIONS_MODAL';
export const IRA_RECURRING_CONTRIBUTION_LIMIT_MODAL =
  'IRA_RECURRING_CONTRIBUTION_LIMIT_MODAL';
export const IRA_WITHHOLDING_WARNING_MODAL = 'IRA_WITHHOLDING_WARNING_MODAL';
export const MIN_FUND_ALERT_MODAL = 'MIN_FUND_ALERT_MODAL';
export const PAPERLESS_TERMS_MODAL = 'PAPERLESS_TERMS_MODAL';
export const CONTACT_ACCOUNT_TEAM_MODAL = 'CONTACT_ACCOUNT_TEAM_MODAL';
export const RI2020_WITHHOLDING_DISCLOSURE_MODAL =
  'RI2020_WITHHOLDING_DISCLOSURE_MODAL';
export const ANNUAL_PERCENTAGE_DISCLAIMER = 'ANNUAL_PERCENTAGE_DISCLAIMER';
export const RMD_DISCLOSURE_MODAL = 'RMD_DISCLOSURE_MODAL';
export const SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS =
  'SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS';
export const SELL_ALL_SHARES_DAILY_LIMIT_MODAL =
  'SELL_ALL_SHARES_DAILY_LIMIT_MODAL';
export const SELL_ALL_SHARES_MODAL = 'SELL_ALL_SHARES_MODAL';
export const SELL_ALL_SHARES_UNCOLLECTED_SHARES =
  'SELL_ALL_SHARES_UNCOLLECTED_SHARES';
export const SELL_FUND_MIN_MAX_MODAL = 'SELL_FUND_MIN_MAX_MODAL';
export const START_DATE_TOOL_TIP = 'START_DATE_TOOL_TIP';
export const IRA_AUTOMAX_START_DATE_TOOL_TIP =
  'IRA_AUTOMAX_START_DATE_TOOL_TIP';
export const SELL_DEDUCTION_REVIEW_MODAL = 'SELL_DEDUCTION_REVIEW_MODAL';
export const REDUCE_AUTO_RMD_DISTRIBUTION_MODAL =
  'REDUCE_AUTO_RMD_DISTRIBUTION_MODAL';
export const STATE_TAX_DISCLOSURE_MODAL = 'STATE_TAX_DISCLOSURE_MODAL';
export const STATE_WITHHOLDING_NON_MANDATORY =
  'STATE_WITHHOLDING_NON_MANDATORY';
export const FEDERAL_INCOME_TAX_WARNING = 'FEDERAL_INCOME_TAX_WARNING';
export const TRANSACTION_POLICY_MODAL = 'TRANSACTION_POLICY_MODAL';
export const AUTOMATIC_TRANSACTION_DELETE = 'AUTOMATIC_TRANSACTION_DELETE';
export const AUTOMATIC_TRANSACTION_DEFER = 'AUTOMATIC_TRANSACTION_DEFER';
export const AUTOMATIC_TRANSACTION_DEFER_CANCEL =
  'AUTOMATIC_TRANSACTION_DEFER_CANCEL';
export const AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS =
  'AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS';
export const AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL =
  'AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL';
export const AUTOMATIC_EDIT_NO_CHANGES_MADE = 'AUTOMATIC_EDIT_NO_CHANGES_MADE';
export const REQUIRED_MINIMUM_DISTRIBUTION_MODAL =
  'REQUIRED_MINIMUM_DISTRIBUTION_MODAL';
export const IRA_AUTO_MAX_CONTRIBUTIONS_MODAL =
  'IRA_AUTO_MAX_CONTRIBUTIONS_MODAL';
export const IRA_AUTO_MAX_TOO_MANY_DAYS_MODAL =
  'IRA_AUTO_MAX_TOO_MANY_DAYS_MODAL';
export const QCD_DAILY_MIN_MAX_MODAL = 'QCD_DAILY_MIN_MAX_MODAL';
// Keep on separate line to make merge cleaner
export const TRANSACTION_LANDING_SELL_FROM_SWEEP =
  'TRANSACTION_LANDING_SELL_FROM_SWEEP';

export const ROTH_DAILY_MINIMUM_MAXIMUM = 'ROTH_DAILY_MINIMUM_MAXIMUM';

export const FINANCIAL_ADVISOR_MODAL = 'FINANCIAL_ADVISOR_MODAL';

export const MIN_MAX_FINANCIAL_ADVISOR_MODAL =
  'MIN_MAX_FINANCIAL_ADVISOR_MODAL';

export const RAS_WITHDRAW_THRESHOLD_MODAL = 'RAS_WITHDRAW_THRESHOLD_MODAL';
export const PAY_TAX_INFORMATION = 'PAY_TAX_INFORMATION';

export const OPEN_MODAL_ANALYTIC_KEYS = {
  [ADD_BANK_MODAL]: 'Add New Bank Landing Page',
  [ADD_SCHOOL_MODAL]: 'Add School Modal',
  [ADD_CHARITY_MODAL]: 'Add Charity Modal',
  [DELETE_SCHOOL_MODAL]: 'Delete School Modal',
  [ADD_FUND_MODAL]: null, // dispatched by internal two steps
  [AWARENESS_MODULE_MODAL]: 'Awareness Module Modal',
  [BALANCES_AS_OF_MODAL]: 'Balance Explanation Modal',
  [APP_TRADE_DATE]: 'App Trade Date Modal',
  [BUCKET_ROLL]: 'BUCKET_ROLL',
  [CANCEL_TRADE_CONFIRMATION_MODAL]: 'Cancel Trade Confirmation Modal',
  [COLLEGE_DISTRIBUTE_FUND_MIN_MAX_MODAL]:
    'College Distribute Fund Min Max Modal',
  [CONTRIBUTION_WINDOW_CLOSED_MODAL]: 'Contribution Window Closed modal',
  [DAILY_MAX_EXCEEDED_MODAL]: 'daily max modal',
  [EXCHANGE_FROM_FUND_MIN_MAX_MODAL]: 'Exchange From Fund Min/Max Modal',
  [BUCKET_ROLL]: 'BUCKET_ROLL',
  [IRA_CONTRIBUTIONS_MODAL]: 'IRA Contributions List Modal',
  [IRA_RECURRING_CONTRIBUTION_LIMIT_MODAL]:
    'IRA Recurring Contribution Limit Modal',
  [IRA_WITHHOLDING_WARNING_MODAL]: 'Sell from IRA withholding warning',
  [MIN_FUND_ALERT_MODAL]: 'Minimum Fund Alert',
  [PAPERLESS_TERMS_MODAL]: 'Paperless Consent Modal',
  [CONTACT_ACCOUNT_TEAM_MODAL]: 'Contact Account Team Modal',
  [RI2020_WITHHOLDING_DISCLOSURE_MODAL]:
    'Retirement Income 2020 Income Tax Withholding Disclosure',
  [RMD_DISCLOSURE_MODAL]: 'Rmd Disclosure Modal',
  [SELL_ALL_SHARES_MODAL]: 'Sell All Shares Disclosure Modal',
  [SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS]:
    'Sell All Shares Closed To New Investors Modal',
  [SELL_ALL_SHARES_DAILY_LIMIT_MODAL]: 'Sell All Shares Daily Limit Modal',
  [SELL_ALL_SHARES_UNCOLLECTED_SHARES]: 'Sell All Shares Uncollected Shares',
  [SELL_FUND_MIN_MAX_MODAL]: 'Sell Fund Min/Max Modal',
  [START_DATE_TOOL_TIP]: 'Start Date Tool Tip',
  [IRA_AUTOMAX_START_DATE_TOOL_TIP]: 'Start Date Tool Tip',
  [REDUCE_AUTO_RMD_DISTRIBUTION_MODAL]: 'Reduce Auto-RMD distribution',
  [SELL_DEDUCTION_REVIEW_MODAL]: 'Sell Deduction Review',
  [STATE_TAX_DISCLOSURE_MODAL]: 'State Tax Disclosure Modal',
  [STATE_WITHHOLDING_NON_MANDATORY]: 'State Withholding Non Mandatory',
  [FEDERAL_INCOME_TAX_WARNING]: 'Federal Income Tax Warning',
  [AUTOMATIC_TRANSACTION_DELETE]: 'AUTOMATIC_TRANSACTION_DELETE',
  [AUTOMATIC_TRANSACTION_DEFER]: 'AUTOMATIC_TRANSACTION_DEFER',
  [AUTOMATIC_TRANSACTION_DEFER_CANCEL]: 'AUTOMATIC_TRANSACTION_DEFER_CANCEL',
  [AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS]:
    'AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS',
  [ANNUAL_PERCENTAGE_DISCLAIMER]: 'ANNUAL_PERCENTAGE_DISCLAIMER',
  [AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL]:
    'AUTOMATIC_TRANSACTION_DEFER_DELETE_FAIL',
  [AUTOMATIC_EDIT_NO_CHANGES_MADE]: 'AUTOMATIC_EDIT_NO_CHANGES_MADE',
  [TRANSACTION_LANDING_SELL_FROM_SWEEP]: 'TRANSACTION_LANDING_SELL_FROM_SWEEP',
  [ROTH_DAILY_MINIMUM_MAXIMUM]: 'ROTH_DAILY_MINIMUM_MAXIMUM',
  [FINANCIAL_ADVISOR_MODAL]: 'FINANCIAL_ADVISOR_MODAL',
  [MIN_MAX_FINANCIAL_ADVISOR_MODAL]: 'MIN_MAX_FINANCIAL_ADVISOR_MODAL',
  [RAS_WITHDRAW_THRESHOLD_MODAL]: 'RAS_WITHDRAW_THRESHOLD_MODAL',
  [PAY_TAX_INFORMATION]: 'PAY_TAX_INFORMATION',
};

const DEFAULT_STATE = {
  modalsSeen: {},
};
export * from './actions';

export default function openModals(state = DEFAULT_STATE, { type, payload }) {
  const { modalName } = payload || {}; // redux itself dispatches each type with null payload

  switch (type) {
    case ModalActionType.OPEN_MODAL: {
      const { modalProps } = payload;
      return {
        ...state,
        [modalName]: coalesce(modalProps, {}),
        modalsSeen: {
          ...state.modalsSeen,
          [modalName]: true,
        },
      };
    }
    case ModalActionType.CLOSE_MODAL: {
      const newState = { ...state };
      delete newState[modalName];
      return newState;
    }
    default: {
      return state;
    }
  }
}
